var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg_img"},[_c('h1',[_vm._v("You are not authorised to view this section please visit "),_c('a',{attrs:{"href":"https://usmart.io/"}},[_vm._v("www.usmart.io")]),_vm._v(" to login.")])])
}]

export { render, staticRenderFns }